import * as React from "react";
import { useSigningAssistant } from "../../hooks";
import useImageApprovals from "../../hooks/useImageApprovals";
import { orderPipeline } from "./orders";

/*
 * Both sources are already fetched for the shop in view — the dashboard calls
 * useSigningAssistant with these exact options, and SWR keys on the URL — so
 * this reads their caches rather than issuing requests of its own.
 *
 * `enabled` is false for shop types that sell nothing of their own, in which
 * case neither request is made and the drawer reports no pipeline at all.
 */
export default function useOrderPipeline({ route, influencerId, enabled }) {
  const { data: signingData } = useSigningAssistant({
    route: enabled ? route : undefined,
    includeCancelledOrders: true,
  });

  const { approvals } = useImageApprovals(influencerId, enabled);

  const imageApprovalsPending = approvals.length;

  return React.useMemo(
    () =>
      enabled
        ? orderPipeline({ signingData, imageApprovalsPending }, new Date())
        : null,
    [enabled, signingData, imageApprovalsPending],
  );
}
